/**
 * The initial value of Symbol.search is the well-known symbol @@search
 * https://tc39.es/ecma262/#sec-symbol.search
 */
export const symbolSearch = () => Symbol("Symbol.search");
